import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=42076aaa&scoped=true&"
import script from "./ComplaintsList.vue?vue&type=script&lang=js&"
export * from "./ComplaintsList.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsList.vue?vue&type=style&index=0&id=42076aaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42076aaa",
  null
  
)

export default component.exports